import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTheme } from '../context/ThemeContext';

export default function WordListLayout({ title, subtitle, accentColor = '#6c63ff', accentColor2, onBack, label, children }) {
    const color2 = accentColor2 || accentColor;
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const bg = isDark
        ? 'linear-gradient(135deg, #0d0d1a 0%, #0f0f23 35%, #0a1628 70%, #0d0d1a 100%)'
        : 'linear-gradient(135deg, #dddaf0 0%, #e0ddf2 35%, #d8e0f0 70%, #dddaf0 100%)';
    const glow1 = isDark ? 'rgba(108,99,255,0.1)' : 'rgba(108,99,255,0.06)';
    const glow2 = isDark ? 'rgba(37,117,252,0.07)' : 'rgba(37,117,252,0.04)';
    const topbarBg = isDark ? 'rgba(13,13,26,0.92)' : 'rgba(220,218,240,0.94)';
    const topbarBorder = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(80,70,140,0.12)';
    const labelColor = isDark ? '#7878a0' : '#5050a0';
    const titleGradient = isDark
        ? `linear-gradient(135deg, #fff 0%, ${accentColor} 60%, ${color2} 100%)`
        : `linear-gradient(135deg, #1a1830 0%, ${accentColor} 60%, ${color2} 100%)`;

    return (
        <Box sx={{
            minHeight: '100vh', width: '100%', background: bg, position: 'relative', overflow: 'hidden',
            '&::before': { content: '""', position: 'fixed', top: '-20%', right: '-10%', width: '60vw', height: '60vw', borderRadius: '50%', background: `radial-gradient(circle, ${glow1} 0%, transparent 70%)`, pointerEvents: 'none', zIndex: 0 },
            '&::after': { content: '""', position: 'fixed', bottom: '-20%', left: '-10%', width: '50vw', height: '50vw', borderRadius: '50%', background: `radial-gradient(circle, ${glow2} 0%, transparent 70%)`, pointerEvents: 'none', zIndex: 0 },
        }}>
            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100 }}>
                <Box sx={{ height: 3, background: `linear-gradient(90deg, ${accentColor}, ${color2})`, opacity: 0.5 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: { xs: 1, sm: 2 }, py: 0.5, background: topbarBg, backdropFilter: 'blur(16px)', borderBottom: `1px solid ${topbarBorder}` }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {onBack && (
                            <IconButton onClick={onBack} size="small" sx={{ color: labelColor, '&:hover': { color: '#6c63ff', background: 'rgba(108,99,255,0.1)' } }}>
                                <ArrowBackIcon fontSize="small" />
                            </IconButton>
                        )}
                        <Typography sx={{ color: labelColor, fontSize: '0.78rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', fontFamily: "'DM Sans', sans-serif" }}>
                            {label || title}
                        </Typography>
                    </Box>
                    <Typography sx={{ color: labelColor, fontSize: '0.78rem', fontFamily: "'DM Sans', sans-serif", pr: { xs: 1, sm: 2 } }}>
                        {subtitle}
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ maxWidth: 780, mx: 'auto', px: { xs: 2, sm: 4 }, pt: { xs: 9, sm: 10 }, pb: 8, position: 'relative', zIndex: 1 }}>
                <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: { xs: '1.8rem', sm: '2.4rem' }, letterSpacing: '-0.03em', background: titleGradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', mb: 0.5 }}>
                        {title}
                    </Typography>
                    <Typography sx={{ color: labelColor, fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem' }}>
                        {subtitle}
                    </Typography>
                </Box>
                {children}
            </Box>
        </Box>
    );
}
